




import { DateUtils } from "../utils/DateUtils";
import { EmployeApi } from "../api/EmployeApi";
import moment from "moment";

export default {
    name: "TotalFraisAll",
    props: {
        selectedMonth: DateUtils.Month,
    },
    data() {
        return {
            notesDeFrais: [],
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        this.getNotesDeFrais();
    },
    methods: {
        getNotesDeFrais() {
            let self = this;
            if (!self.selectedMonth) {
                return;
            }
            let date = moment(
                self.selectedMonth.year + "-" + self.selectedMonth.month,
                "YYYY-MM"
            );
            self.notesDeFrais = [];
            self.EmployeApi.getAll({
                include: "note_de_frais",
                month: date.format("YYYY-MM"),
            }).then(function (employes) {
                self.notesDeFrais = [];
                _.each(employes, function (employe) {
                    if (employe.note_de_frais) {
                        self.notesDeFrais.push(employe.note_de_frais);
                    }
                });
            });
        },
    },
    computed: {
        total() {
            let self = this;
            let total = _.reduce(
                self.notesDeFrais,
                function (sum, noteDeFrais) {
                    if (noteDeFrais.total) {
                        return (sum += noteDeFrais.total);
                    }
                    return sum;
                },
                0
            );
            return _.round(total, 2);
        },
    },
    watch: {
        selectedMonth: "getNotesDeFrais",
    },
};
